"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInput = exports.FormInputContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const Label_1 = require("../Label");
exports.FormInputContainer = styled_components_1.default.div `
  display: grid;
  row-gap: ${style_1.default.Layout.Spacing.Micro};
  width: 100%;
`;
;
function identity(input) {
    return input;
}
function FormInput({ Component, accessor, isDisabled = false, label, onChange, props, source, transform = identity, }) {
    // Determine the value to feed to the component.
    const value = react_1.default.useMemo(() => {
        return R.prop(accessor, source);
    }, [accessor, source]);
    // Fired when the component changes the value.
    const handleOnChange = react_1.default.useCallback((next, context) => {
        const transformed = transform(next);
        onChange(R.set(R.lensProp(accessor), transformed, source), context);
    }, [onChange, accessor, source]);
    return ((0, jsx_runtime_1.jsxs)(exports.FormInputContainer, { children: [!R.isNil(label) && ((0, jsx_runtime_1.jsx)(Label_1.Label, { children: label })), (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props, { isDisabled: isDisabled, onChange: handleOnChange, value: value }))] }));
}
exports.FormInput = FormInput;
